/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPONCEOFFINVESTMENTSOURCEOFMONEY = {
    LivingAnnuity: '0',
    RetirementBenefit: '1',
    OtherSources: '2',
    RetirementAnnuity: '3',
    Combination: '4'
} as const;
export type IAPONCEOFFINVESTMENTSOURCEOFMONEY = typeof IAPONCEOFFINVESTMENTSOURCEOFMONEY[keyof typeof IAPONCEOFFINVESTMENTSOURCEOFMONEY];


export function IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSON(json: any): IAPONCEOFFINVESTMENTSOURCEOFMONEY {
    return IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSONTyped(json, false);
}

export function IAPONCEOFFINVESTMENTSOURCEOFMONEYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPONCEOFFINVESTMENTSOURCEOFMONEY {
    return json as IAPONCEOFFINVESTMENTSOURCEOFMONEY;
}

export function IAPONCEOFFINVESTMENTSOURCEOFMONEYToJSON(value?: IAPONCEOFFINVESTMENTSOURCEOFMONEY | null): any {
    return value as any;
}

